module.exports = {
  theme: {
    colors: {
      primary: '#00c777',
      'primary-light': '#81dbab',
    },
  },
};
